import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SystemMessage } from '@alfa-bank/newclick-composite-components/system-message';
import cn from 'classnames';
import { Button } from '@alfalab/core-components/button';
import { PopupSheet } from '@alfalab/core-components/popup-sheet';
import { Typography } from '@alfalab/core-components/typography';
import { ExclamationMIcon } from '@alfalab/icons-glyph/ExclamationMIcon';
import { useVoipContext } from '../../hooks/use-voip-context';
import { useWebview } from '../../hooks/use-webview';
import { useWidgetContext } from '../../hooks/use-widget-context';
import styles from './index.module.css';
export const Popup = () => {
    const { openedPopup, setOpenedPopup, theme } = useWidgetContext();
    const { bridgeToNative } = useWebview();
    const { cancelCall } = useVoipContext();
    const closePopup = () => {
        setOpenedPopup(false);
    };
    const closeWebview = () => {
        closePopup();
        cancelCall();
        bridgeToNative?.closeWebview();
    };
    return (_jsx(PopupSheet, { open: openedPopup, onClose: closePopup, padding: 'var(--gap-32) var(--gap-20)', hasCloser: true, className: cn(styles[theme]), children: _jsxs(SystemMessage, { children: [_jsx(SystemMessage.Graphic, { Icon: ExclamationMIcon }), _jsx(SystemMessage.Title, { children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A?" }), _jsxs(SystemMessage.Controls, { direction: 'row', children: [_jsx(Button, { view: 'secondary', onClick: closePopup, className: styles.marginRight, children: _jsx(Typography.Text, { weight: 'medium', children: "\u041E\u0442\u043C\u0435\u043D\u0430" }) }), _jsx(Button, { view: 'primary', children: _jsx(Typography.Text, { weight: 'medium', onClick: closeWebview, children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C" }) })] })] }) }));
};
